import { Link } from 'gatsby'
import React from 'react'

import { useAnalyticsEvents } from '../../../../hooks/useAnalyticsEvents'
import { textHighlighted } from '../../../../utils/dropdownSearchFunctions'

import type {
  SearchDropdownListItemProps,
  SearchItem,
} from '../../../../types/SearchDropdown'

import './search-dropdown-list-item.scss'

export const SearchDropdownListItem = ({
  searchedItems,
  searchedTerm,
  trigger,
  isAisles,
  noHighlighted,
  updateSearchBar,
  sectionTitle,
}: SearchDropdownListItemProps) => {
  const { genericTaggingEvent } = useAnalyticsEvents()
  const isTermValid = searchedTerm && searchedTerm.split('').length >= 3

  if (!searchedItems || searchedItems.length <= 0) {
    return null
  }

  const displayedItems = searchedItems.slice(0, 5)
  const handleRedirectionToSearch = (item: SearchItem) => {
    trigger?.(isAisles ? searchedTerm : item.text, item.link, updateSearchBar)
    genericTaggingEvent('quick_search', {
      searchText: searchedTerm ?? '',
      selectionType: sectionTitle,
      selectedText: item.text,
    })
  }

  return (
    <>
      {displayedItems?.map((item: SearchItem) => {
        return (
          <div
            key={item.text}
            data-testid="search-item-list"
            className="search-item-list"
          >
            <Link
              to={item?.link ?? ''}
              onClick={() => handleRedirectionToSearch(item)}
            >
              {isTermValid && !noHighlighted ? (
                <span
                  data-testid="text-highlighted"
                  dangerouslySetInnerHTML={{
                    __html: textHighlighted(
                      item.text,
                      searchedTerm,
                      isAisles,
                      item.quantity
                    ),
                  }}
                />
              ) : (
                <span
                  className="text-no-highlighted"
                  data-testid="text-no-highlighted"
                >
                  {item.text}
                </span>
              )}
            </Link>
          </div>
        )
      })}
    </>
  )
}
